import { RestfulSiteAnnouncementWebService, SiteAnnouncementWebService } from 'ws/SiteAnnouncementWebService';
import { SiteAnnouncement, SiteAnnouncementFormData, SiteAnnouncementListDTO } from './SiteAnnouncement';
import { omit } from 'lodash';

export interface SiteAnnouncementManager {
  getSiteAnnouncement: (announcementId: number) => Promise<SiteAnnouncement>;
  getSiteAnnouncements: () => Promise<SiteAnnouncementListDTO[]>;
  createSiteAnnouncement: (announcement: SiteAnnouncementFormData) => Promise<void>;
  updateSiteAnnouncement: (id: number, announcement: SiteAnnouncementFormData) => Promise<void>;
  // 每個通知分類各回最新一則（依 publishTime DESC），無資料時回空陣列
  getTopAnnouncement: (vendorNumber: string) => Promise<SiteAnnouncement[]>;
  activateAnnouncements: (ids: number[]) => Promise<void>;
  deactivateAnnouncements: (ids: number[]) => Promise<void>;
  deleteAnnouncements: (ids: number[]) => Promise<void>;
}

export class DefaultSiteAnnouncementManager implements SiteAnnouncementManager {

  constructor (
    private webService: SiteAnnouncementWebService = new RestfulSiteAnnouncementWebService()
  ) {}

  async getSiteAnnouncement (announcementId: number): Promise<SiteAnnouncement> {
    return this.webService.getSiteAnnouncement(announcementId);
  }

  async getSiteAnnouncements (): Promise<SiteAnnouncementListDTO[]> {
    return this.webService.getSiteAnnouncements();
  }

  async createSiteAnnouncement (announcement: SiteAnnouncementFormData): Promise<void> {
    return this.webService.createSiteAnnouncement(omit(announcement, 'chooseVendorStrategy', 'shouldResend'));
  }

  async updateSiteAnnouncement (id: number, announcement: SiteAnnouncementFormData): Promise<void> {
    return this.webService.updateSiteAnnouncement({
      ...omit(announcement, 'chooseVendorStrategy'),
      id
    });
  }

  async getTopAnnouncement (vendorNumber: string): Promise<SiteAnnouncement[]> {
    return this.webService.getTopAnnouncement(vendorNumber);
  }

  async activateAnnouncements (ids: number[]): Promise<void> {
    return this.webService.activateAnnouncements(ids);
  }

  async deactivateAnnouncements (ids: number[]): Promise<void> {
    return this.webService.deactivateAnnouncements(ids);
  }

  async deleteAnnouncements (ids: number[]): Promise<void> {
    return this.webService.deleteAnnouncements(ids);
  }
}
